import { useState } from 'react';

// Shared across every page that writes to an org with no Marketplace link
// (internal/dogfood/test orgs) -- the backend now requires this on
// set-web-application-state, set-initial/streaming-application-state,
// set-organisation, governance-config, crossplane-request, and the
// load-test endpoints. Same storage key as deployments/root.tsx so
// entering it once on any page carries over to the others.
const ADMIN_TOKEN_STORAGE_KEY = 'ncoda.internalAdminToken';

export function useAdminToken() {
  const [adminToken, setAdminTokenState] = useState<string>(
    () => window.localStorage.getItem(ADMIN_TOKEN_STORAGE_KEY) ?? ''
  );

  const setAdminToken = (value: string) => {
    setAdminTokenState(value);
    window.localStorage.setItem(ADMIN_TOKEN_STORAGE_KEY, value);
  };

  return [adminToken, setAdminToken] as const;
}

export function adminAuthHeader(adminToken: string): Record<string, string> {
  return adminToken ? { Authorization: `Bearer ${adminToken}` } : {};
}
